/**
 * Player slice.
 */
import MediaProduction from '@shared/classes/mediaProduction';
import FastEvent from '@shared/classes/fastEvent';
import { IPlayerState } from '@shared/types/interfaces/states';
import { RootState } from '@shared/store/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Initial state.
 */
const initialState: IPlayerState = {
  nextEpisode: {
    asset: undefined,
    display: false,
    enabled: false,
    percentage: 0,
  },
};

const playerSlice = createSlice({
  name: 'player',
  initialState,
  reducers: {
    /**
     * Reset player state.
     */
    resetPlayer: (state) => {
      state.nextEpisode = {
        asset: undefined,
        display: false,
        enabled: false,
        percentage: 0,
      };
    },
    /**
     * Set next episode state.
     */
    setNextEpisode: (
      state,
      action: PayloadAction<{
        asset?: FastEvent | MediaProduction;
        display?: boolean;
        enabled?: boolean;
        percentage?: number;
      }>
    ) => {
      // Display next episode when it becomes available
      if (!state.nextEpisode.enabled && action.payload.enabled) {
        state.nextEpisode.display = true;
      }
      // Hide when not available
      if (!action.payload.enabled) {
        state.nextEpisode.display = false;
      }
      // Set any attributes passed through parameters
      state.nextEpisode = { ...state.nextEpisode, ...action.payload };
    },
  },
});

const { actions, reducer: playerReducer } = playerSlice;
export const { resetPlayer, setNextEpisode } = actions;
export const playerSelector = (state: RootState) => state.player;
export default playerReducer;
